export default "__VITE_ASSET__Aq$BmFTy__"